import React from 'react';

/**
 * EnvBanner — a full-width strip that tells an admin whether they're looking at
 * the LIVE production database or the PREVIEW/dev database (test data). Prevents
 * confusion between real orders (production) and QA/test entries (preview).
 */
const isPreview = () => {
  const h = (typeof window !== 'undefined' && window.location.hostname) || '';
  return h.includes('preview.emergentagent.com') || h.includes('localhost') || h.startsWith('127.');
};

export const EnvBanner = () => {
  const preview = isPreview();
  if (preview) {
    return (
      <div
        className="w-full bg-amber-400 text-black text-center py-2 px-4 text-[11px] font-black tracking-[0.25em] uppercase"
        data-testid="env-banner-preview"
      >
        ⚠ Preview · Test Data — real orders live at prsvr.store/admin
      </div>
    );
  }
  return (
    <div
      className="w-full bg-emerald-600 text-white text-center py-2 px-4 text-[11px] font-black tracking-[0.25em] uppercase"
      data-testid="env-banner-live"
    >
      ● Live · Production Data
    </div>
  );
};

export default EnvBanner;
